/* Source: https://www.npmjs.com/package/react-colorful */
import React, { useCallback, useRef, useState, useEffect } from "react";
import { HexColorPicker } from "react-colorful";

import useClickOutside from "./useClickOutside";

export const PopoverPicker = ({ color, onChange, disabled=false }) => {
  const popover = useRef();
  const [isOpen, toggle] = useState(false);

  let style = { backgroundColor: color };
  if (disabled) {
    style["cursor"] = "default";
  }

  const close = useCallback(() => toggle(false), []);
  useClickOutside(popover, close);

  return (
    <div className="picker">
      <div
        className="color-preview"
        style={style}
        onClick={disabled ? null : () => toggle(true)}
      />

      {isOpen && (
        <div className="popover" ref={popover}>
          <HexColorPicker color={color} onChange={onChange} />
        </div>
      )}
    </div>
  );
};
